"use client";
import React from "react";
import {
  type UploadDialogProps,
  UploadStatusDialog,
} from "@/components/transcriptions/UploadDialog";
import {
  type HomepageEntryVariant,
  withHomepageEntryVariant,
} from "@/lib/homepage-entry-experiment";

export const UploadDialogLanding = ({
  homepageEntryVariant,
  ...props
}: UploadDialogProps & { homepageEntryVariant?: HomepageEntryVariant }) => (
  <UploadStatusDialog
    {...props}
    successHref={withHomepageEntryVariant(
      `/demo/transcriptions/${props.jobId}`,
      homepageEntryVariant
    )}
  />
);
